<template>
  <el-card class="box-card">
  <div class="batchBox">
    <div style="margin-top: 20px;">
     <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="cusName">
              <!--<el-input v-model="rowInfo.cusName" placeholder="企业名称" style="width: 220px"/>-->
              <span  style="width: 220px">{{rowInfo.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业简称">
             <!-- <el-input v-model="rowInfo.cusShortName" placeholder="企业简称" style="width: 220px"/>-->
               <span  style="width: 220px">{{rowInfo.cusShortName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业logo">
              <!-- <img-upload
                 v-model="rowInfo.cusLogoAttachmentId"
                 :url="rowInfo.cusLogoUrl"
               />-->
              <img :src="rowInfo.cusLogoUrl" style="width:50px;height: 50px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办公地址">
              <!--<el-input v-model="rowInfo.address" placeholder="办公地址" style="width: 220px"/>-->
                <span  style="width: 220px">{{rowInfo.address}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业负责人">
             <!-- <el-input v-model="rowInfo.cusHead" placeholder="企业负责人" style="width: 220px"/>-->
              <span  style="width: 220px">{{rowInfo.cusHead}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="cusPhone">
             <!-- <el-input v-model="rowInfo.cusPhone" placeholder="联系电话" style="width: 220px"/>-->
               <span  style="width: 220px">{{rowInfo.cusPhone}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="12">
            <el-form-item label="联系邮箱" prop="cusEmail">
              <!--<el-input v-model="rowInfo.cusEmail" placeholder="联系邮箱" style="width: 220px"/>-->
              <span  style="width: 220px">{{rowInfo.cusEmail}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <!--<el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:85%;"/>-->
                <span  style="width:85%;">
                  {{rowInfo.remark}}
                </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
      <span slot="footer" class="dialog-footer">
       <!-- <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>-->
        <!--<el-button size="mini"  @click="closeForm">取消</el-button>-->
    </span>
    </div>
  </div>
  </el-card>
</template>
<script>
  import SelectText from '@/components/SelectText/index.vue'
  import ImgUpload from '@/components/ImgUpload/index.vue'
  import { addListpage,getCusInfo } from  "@/api/cus/cusinfo"
  import { mapGetters } from 'vuex';
  export default {
    components: {
      SelectText,ImgUpload
    },
    computed: {
      headers() {
        return {
          Authorization: `Bearer ${this.accessToken}`,
        };
      },
      ...mapGetters(['accessToken','userInfo'])
    },
    data() {
      // 手机号
      let validatePhone = (rule, value, callback) => {
        let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value && !isNum.test(value)) {
          callback(new Error('请输入正确的电话'))
        }
        callback()
      }
      let validateEmail = (rule, value, callback) => {
        let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
        if (value && !isNum.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        }
        callback()
      }
      return {
        visible: false,
        formName: '新增',
        uploadUrl: process.env.VUE_APP_BASE_API + '/attach/upload',
        loading: false,
        rowInfo: {
          id: '',
          cusName: '',
          cusShortName: '',
          address: '',
          cusHead: '',
          cusLogoAttachmentId: '',
          cusPhone: '',
          cusEmail: '',
          cusLogoUrL: '',
          status: 1,
          remark: ''
        },
        rules: {
          cusName: [{ required: true, message: '必填:企业名称', trigger: 'blur' }],
          cusPhone: [
            { validator: validatePhone, trigger: 'blur' }
          ],
          cusEmail: [
            { validator: validateEmail, trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        getCusInfo().then((res) => {
          if(res.data.code==0){
            let data = res.data
            this.rowInfo = data.data
            if(data.data.cusLogoUrl){
              this.$set(this.rowInfo,'cusLogoUrl',process.env.VUE_APP_BASE_API+''+data.data.cusLogoUrl)
            }
          }
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            addListpage(this.rowInfo).then((res) => {
              // 在store中改变修改的值
              this.$message.success("保存成功")
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .dialog-footer{
    display: flex;
    justify-content: center;
  }
</style>
